import { toFullOption } from 'react-querybuilder';
import { getInputTypeForField, getOperatorsForField } from "./fieldTypeUtils";
import { validator } from './validatorConfig';
import { booleanValues } from '../EnvQueryConfig';

export const processFieldsToQueryBuilderFormat = (fields = [], fieldValues = {}, fieldMetadata = []) => {
  const fieldDefinitions = (fields || []).map(fieldName => {
    const metadata = fieldMetadata.find(m => m.name === fieldName);
    const values = fieldValues[fieldName] || [];
    console.log(`Processing field: ${fieldName}, metadata: ${JSON.stringify(metadata)}, values: ${JSON.stringify(values)}`);
    const variableType = metadata?.variableType;
    const displayName = metadata?.displayName || fieldName;
    const hasTranslation = metadata?.hasTranslation;

    const operators = getOperatorsForField(variableType, hasTranslation);
    const inputType = getInputTypeForField(variableType, hasTranslation);
    
    // Build field definition following library conventions
    const fieldDef = {
      name: fieldName,
      label: displayName,
      placeholder: `Enter ${displayName}`,
      validator,
      operators: operators,
      defaultOperator: operators[0]?.name || '=',
      valueSources: ['value'],
      variableType: variableType,
      hasTranslation: hasTranslation
    };
    
    // Add inputType for fields that need HTML input type (number, text, date, etc.)
    if (inputType && inputType !== null) {
      fieldDef.inputType = inputType;
    }
    
    // Set valueEditorType and values based on field type
    if (variableType === 'BOOL') {
       fieldDef.valueEditorType = 'radio';
      fieldDef.values = booleanValues;
      fieldDef.defaultValue = 'true';
    } else {
      fieldDef.valueEditorType = 'text';
    }
    
    return fieldDef;
  });
  
  // Convert to FullField format using library's toFullOption
  return fieldDefinitions.map((field) => toFullOption(field));
};
